import { watch, unref, computed } from 'vue';

const toValue = (mayBeRefOrFunc) => {
    if (typeof mayBeRefOrFunc === 'function') {
        return mayBeRefOrFunc();
    } else {
        return unref(mayBeRefOrFunc);
    }
};

const unrefEl = (elRef) => {
    const plain = toValue(elRef);
    return plain?.$el ?? plain;
};

export const useResizeObserver  = (
    target,
    callback,
    options = {},
  ) => {
    const { ...observerOptions } = options
    let observer;
    const isSupported = Boolean(window && 'ResizeObserver' in window);

    const cleanup = () => {
      if (observer) {
        observer.disconnect()
        observer = undefined
      }
    }

    const targets = computed(() =>
      Array.isArray(toValue(target))
        ? toValue(target).map(el => unrefEl(el))
        : [unrefEl(target)]);

    const stopWatch = watch(
      targets,
      (els) => {
        cleanup()
        if (isSupported && window) {
          observer = new ResizeObserver(callback)
          for (const _el of els) {
            _el instanceof Element && observer?.observe(_el, observerOptions)
          }
        }
      },
      { immediate: true, flush: 'post' },
    )

    const stop = () => {
      cleanup()
      stopWatch()
    }

    return {
      stop,
    }
  }
